/* eslint-disable no-use-before-define */

import { DateTime } from 'luxon';
import moment from 'moment';

export function usePrivacytoString(detail, logo, width) {
    // const [width, setWidth] = useState(0);

    const personalDataCollection = detail?.personalDataCollection;
    const disclosurePersonalData = detail?.disclosurePersonalData;
    // const personalDataTopic = detail?.disclosurePersonalData?.personalDataTopic;
    const dataSubjectRightAndSecure = detail?.dataSubjectRightAndSecure;
    const marketingAdvertising = detail?.marketingAdvertising;
    const privacyPolicy = detail?.privacyPolicy;
    const dataController = detail?.dataController;
    const dpo = detail?.dpo;

    const date = moment(detail?.lastUpdate).format('DD-MM-YYYY');

    return {
        html: `
        <html>
        <head>
            <meta charset="UTF-8" />
            <title>Document</title>
            <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.5/FileSaver.min.js"></script>
            <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
        </head>
        <body style="word-break: break-word;">
    <center>
    ${
        logo &&
        `<img style="object-fit: cover;" src=${logo} width="${width}" height="100" alt="logo "/>`
    }</center>
        <center><h3>ประกาศการคุ้มครองข้อมูลส่วนบุคคล ${
            personalDataCollection?.companyNameTh || '-'
        }</h3></center>
        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;${
                personalDataCollection?.companyNameTh || '-'
            } (“บริษัท”)
            ขอแนะนำให้ท่านทำความเข้าใจประกาศการคุ้มครองข้อมูลส่วนบุคคล (privacy
            notice) นี้ เนื่องจาก
            ประกาศนี้อธิบายถึงวิธีการที่บริษัทปฏิบัติต่อข้อมูลส่วนบุคคลของท่าน
            เช่น การเก็บรวบรวม การจัดเก็บรักษา การใช้ การเปิดเผย
            รวมถึงสิทธิต่างๆ ของท่าน ในฐานะที่เป็นเจ้าของข้อมูลส่วนบุคคล
            โดยอ้างอิงตาม นโยบายคุ้มครองข้อมูลส่วนบุคคลขอ${
                personalDataCollection?.companyNameTh || '-'
            } เป็นต้น
            เพื่อให้ท่านได้รับทราบถึงมาตรการในการคุ้มครองข้อมูลส่วนบุคคลของบริษัท
            บริษัทจึงประกาศการคุ้มครองข้อมูลส่วนบุคคล ดังต่อไปนี้
        </p>

        ${
            disclosurePersonalData?.personalDataOptionSequence?.length !== 0 ||
            disclosurePersonalData?.sensitivePersonalDataOptionSequence
                ?.length !== 0
                ? `<h4>ข้อมูลส่วนบุคคล</h4>
                <p>
                    “ข้อมูลส่วนบุคคล” หมายถึง
                    ข้อมูลที่สามารถระบุตัวตนของท่าน
                    หรืออาจจะระบุตัวตนของท่านได้
                    ไม่ว่าทางตรงหรือทางอ้อม
                </p>
                <h4>การเก็บรวบรวมข้อมูลส่วนบุคคล</h4>
                <p>
                    ข้อมูลส่วนบุคคลของท่านที่บริษัทเก็บรวบรวม
                    ใช้ และ/หรือเปิดเผย มีดังนี้
                </p>
                <table
                    border="1"
                    style="width: 100%;
                    border-collapse: collapse;
                    border-style: hidden;
                    border-color: #f9f9f9;
                    background-color: #f9f9f9;
                    margin-bottom: 5px;
                    text-align: left;
                    padding: 1rem;
                    border-radius: 6;"
                >
                    <thead>
                        <tr>
                            <th
                                style="padding:1rem"
                            >
                                ประเภทข้อมูล
                            </th>
                            <th
                            style="padding:1rem"
                            >
                                รายละเอียดข้อมูล
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        ${
                            disclosurePersonalData?.personalDataOptionSequence
                                ?.length !== 0
                                ? `<tr
                                style="border-top:1px solid #e9e9e9"
                            >
                                <td
                                    style="width:40%;padding-left:1.5rem"
                                >
                                    ข้อมูลส่วนบุคคล
                                </td>
                                <td>
                                    <ul
                                    style="padding-left:1.5rem;"
                                    >
                                        ${disclosurePersonalData?.personalDataOptionSequence
                                            ?.map(
                                                (option) =>
                                                    `<li>
                                                    ${option.personDataOptionNameTh}
                                                </li>`
                                            )
                                            .join(' ')}
                                    </ul>
                                </td>
                            </tr>`
                                : ''
                        }
                        ${
                            disclosurePersonalData
                                ?.sensitivePersonalDataOptionSequence
                                ?.length !== 0
                                ? `<tr style="border-top:1px solid #e9e9e9">
                                    <td style="width:40%;padding-left:1.5rem">
                                        ข้อมูลส่วนบุคคลอ่อนไหว
                                    </td>
                                    <td>
                                        <ul style="padding-left:1.5rem;">
                                            ${disclosurePersonalData?.sensitivePersonalDataOptionSequence
                                                ?.map(
                                                    (option) =>
                                                        `<li>
                                                        ${option.sensitivePersonDataOptionNameTh}
                                                    </li>`
                                                )
                                                .join(' ')}
                                        </ul>
                                    </td>
                                </tr>`
                                : ''
                        }
                    </tbody>
                </table>`
                : ''
        }
 
        <h4>แหล่งที่มาของข้อมูลส่วนบุคคล</h4>
        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;บริษัทอาจได้รับข้อมูลส่วนบุคคลของท่านจากช่องทางดังนี้
        </p>
        ${
            personalDataCollection?.dataSourceFromDs
                ? `<h4>การเก็บข้อมูลโดยตรงจากท่าน</h4> ${
                      personalDataCollection?.dataSourceFromDsTh || '-'
                  }`
                : ''
        }
        ${
            personalDataCollection?.dataSourceFromOther
                ? `<h4>การเก็บข้อมูลจากแหล่งอื่น</h4> ${
                      personalDataCollection?.dataSourceFromOtherTh || '_'
                  } `
                : ''
        }
        <h4>วัตถุประสงค์การเก็บ รวบรวม ใช้และเปิดเผย</h4>
        ${personalDataCollection?.purposeOfDataCollectionTh || '-'}
        <h4>การเปิดเผยข้อมูลส่วนบุคคลให้บุคคลอื่น</h4>
        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;บริษัทจะไม่เปิดเผยข้อมูลส่วนบุคคลของท่านกับบุคคลและนิติบุคคลอื่นที่ไม่ได้เป็นบริษัทในกลุ่มของบริษัท
            (“บุคคลอื่น”)
            เว้นแต่เป็นการเปิดเผยเพื่อบรรลุวัตถุประสงค์การเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลตามที่ระบุไว้ในประกาศความเป็นส่วนตัวนี้
            โดยบริษัทอาจเปิดเผยข้อมูลส่วนบุคคลของท่านให้บุคคลอื่น เช่น
        </p>
        ${disclosurePersonalData?.discloseToOtherPersonTh || '-'}
        <h4>ระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล</h4>
        ${disclosurePersonalData?.retentionPeriodTh || '-'}
        <h4>การส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปต่างประเทศ</h4>
        ${disclosurePersonalData?.transferPersonalDataTh || '-'}

        <h4>สิทธิของท่านเกี่ยวกับข้อมูลส่วนบุคคล</h4>
        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;
            ท่านสามารถขอใช้สิทธิของท่านภายใต้ข้อกำหนดของกฎหมาย
            และนโยบายที่กำหนดไว้ในขณะนี้หรือที่จะมีการแก้ไขเพิ่มเติมในอนาคต
            ตลอดจนหลักเกณฑ์ตามที่บริษัทกำหนด
        </p>
        <ul>
            <li>
                <h4>สิทธิขอเพิกถอนความยินยอม</h4>
                ${dataSubjectRightAndSecure?.rightToWithdrawConsentTh || '-'}
            </li>
            <li>
                <h4>สิทธิขอเข้าถึงข้อมูลและขอรับสำเนา</h4>
                ${dataSubjectRightAndSecure?.rightOfAccessTh || '-'}
            </li>
            <li>
                <h4>สิทธิขอถ่ายโอนข้อมูล</h4>
                ${dataSubjectRightAndSecure?.rightOfDataPortabilityTh || '-'}
            </li>
            <li>
                <h4>สิทธิขอคัดค้าน</h4>
                ${dataSubjectRightAndSecure?.rightToObjectTh || '-'}
            </li>
            <li>
                <h4>สิทธิขอระงับการใช้ข้อมูล</h4>
                ${dataSubjectRightAndSecure?.rightToRestrictProcessingTh || '-'}
            </li>
            <li>
                <h4>สิทธิขอให้ลบหรือทำลายข้อมูล</h4>
                ${dataSubjectRightAndSecure?.rightToErasureTh || '-'}
            </li>
            <li>
                <h4>สิทธิขอให้แก้ไขข้อมูล</h4>
                ${dataSubjectRightAndSecure?.rightToRectificationTh || '-'}
            </li>
            ${
                dataSubjectRightAndSecure?.rightToComplaintTh
                    ? `<li>
                        <h4>สิทธิขอร้องเรียนข้อมูล</h4>
                        ${dataSubjectRightAndSecure?.rightToComplaintTh || '-'}
                    </li>`
                    : ''
            }
        </ul>
        <h4>มาตรการรักษาความมั่นคงปลอดภัยและคุณภาพของข้อมูล</h4>
        ${dataSubjectRightAndSecure?.securityMeasureTh || '-'}
        <h4>กิจกรรมทางการตลาดและการส่งเสริมการตลาด</h4>
        ${marketingAdvertising?.marketingActivityTh || '-'}
        <h4>นโยบายคุ้มครองข้อมูลส่วนบุคคลของเว็บไซต์อื่น</h4>
        ${privacyPolicy?.policyWebsiteTh || '-'}
        <h4>ในกรณีที่ท่านปฏิเสธไม่เปิดเผยหรือให้ใช้ข้อมูลส่วนบุคคล</h4>
        ${privacyPolicy?.undisclosedReasonTh || '-'}
        <h4>การดำเนินการ แนวปฏิบัติ และนโยบายที่เกี่ยวกับข้อมูลส่วนบุคคล</h4>
        ${privacyPolicy?.processPolicyTh || '-'}
        <h4>เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล</h4>
        ${dpo?.dpoNameTh || '-'}
        <h4>ช่องทางการติดต่อบริษัท</h4>
        ${dataController?.contactChannelTh || '-'}
        <h4>ฉบับ ณ วันที่ ${
            personalDataCollection?.effectiveDate
                ? DateTime.fromISO(personalDataCollection?.effectiveDate, {
                      locale: 'th',
                  }).toLocaleString(DateTime.DATE_FULL)
                : '-'
        }</h4>
        <script type="text/javascript">
                $(document).ready(function() {
                let allElements = $('*');
                let converted = htmlDocx.asBlob(allElements.html());
                saveAs(converted, '${
                    personalDataCollection?.privacyPolicyNoticeNameTh +
                    `_${date}_TH.docx`
                }');
                setTimeout(()=> window.close(), 100)
                });
        </script>
    </body>
</html>`,
    };
}
